import React from 'react'
import LayoutToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'
import { defaultProps } from '.'
import { ToolbarSection } from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ToolbarItem'

export const ApplicazioniSectionSettings = (settingsProps) => {
  const themeOpts = [
    { label: 'Bianco', value: 'white' },
    { label: 'Grigio chiaro', value: 'neutral10' },
    { label: 'Grigio', value: 'neutral20' },
  ]

  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="theme"
          type="select"
          options={themeOpts}
          label="Sfondo"
          defaultValue={defaultProps['theme']}
        />
      </ToolbarSection>
      <LayoutToolbarSection defaultProps={defaultProps} initOpen />
    </>
  )
}

export const ApplicazioniSectionFloatingSettings = () =>
  React.createElement(ApplicazioniSectionSettings, { floating: true })
